import slugify from 'slugify'

export function createSlug(name: string, slug?: string) {
  const nameSlug = slugify(name, { lower: true })
  if (slug) {
    if (nameSlug === '') {
      return slug
    } else {
      return `${nameSlug}-${slug}`
    }
  }
  return nameSlug
}

/*
import slugify from 'slugify'

export function createSlug(input: string, id?: string) {
  const slug = slugify(input, { lower: true })
  if (id) {
    if (slug === '') {
      return id
    } else {
      return `${slug}-${id}`
    }
  }
  return slug
}
*/
